import { styled } from "styled-components";

export const Form = styled.div`
  > div > div {
    padding: 20px 24px 24px 24px;
    > form {
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: flex-end;

      ${({ theme }) => theme.breakpoints.sm.query} {
        flex-wrap: wrap;
        button {
          width: 100%;
        }
      }
    }
  }
`;
